import news from './news';
import news_data from './data';
import news_image from './image';
import news_modal from './modal';
import RepeatedTask from '../repeated_task';
import util from '../utils';
import visibility from '../visibility';

export default config => {
    $(() => {
        // On load categories are loaded but when clicked until category clicked is rendered this param is false
        config.isCategoryLoaded = true;
        const linkTemplate = config.widget_apis.news_template;
        // get top "category" data and fill top slider
        // @todo replace 1 with currently needed top provider id

        news.handleMoreCategoriesClick();

        const topNewsReload = new RepeatedTask(function () {
            if (visibility.isHidden) {
                return false; // stuck
            }

            if (!util.visibilityObserver.isVisible(news.selectors.topCarousel)) {
                return false; // stuck
            }

            if ($('#modal-news:visible').length) {
                return true;
            }

            news_data.getFeedData(
                linkTemplate.url,
                linkTemplate.fallback_url,
                'source',
                news_data.getTopProvider(),
                news_data.categoryTop,
                function (feedData) {
                    news.fillTopSlider(feedData.articles, feedData.categories, feedData.sources, 'category', news_data.categoryTop);
                }
            );

            return true;
        }, config.news_conf.reload_interval);

        visibility.onChange(function (isHidden) {
            if (isHidden) {
                return;
            }

            if (topNewsReload.stuck) {
                topNewsReload.run();
            }
        });

        var onIntersecting = function (entry/* , observer */) {
            if (!entry.isIntersecting) {
                return true;
            }

            if ('#' + entry.target.id == news.selectors.topCarousel && topNewsReload.stuck) {
                topNewsReload.run();
            }
        };

        Object.values(news.selectors).forEach(item => {
            const
                selector = item.slice(1),
                container = document.getElementById(selector);
            if (container !== null) {
                util.visibilityObserver.observe(container, onIntersecting);
            }
        });

        /*
        Switching categories event
    */
        $('body').on('click', '.news-select', function (e) {
            var $tg = $(e.target);
            if (!$tg.is('a')) {
                return;
            }

            //check if previous category click is loaded before allowing new category to be clicked
            if (!config.isCategoryLoaded) {
                setTimeout(function(){
                    $tg.trigger('click'); //try again
                }, 300);

                return false;
            }

            config.isCategoryLoaded = false; //reset category loaded status

            var currCategoryChosen = $tg.data('filtercategory');
            var currCategoryType = $tg.data('categorytype');

            var carouselToUpdateId = $(this).closest('.carousel_outer_wrap').attr('id');

            var sourceId = 0, categoryId = 0;

            if (carouselToUpdateId === "carousel_slider_top") {
                topNewsReload.postpone();
                sourceId = news_data.getTopProvider();
                categoryId = currCategoryChosen;
            } else {
                sourceId = currCategoryChosen;
                categoryId = currCategoryChosen == news_data.categoryAll ? news_data.categoryAll : news_data.categoryTop;
            }
            news.updateSliderWithCategoryData(currCategoryType, sourceId, categoryId, currCategoryChosen, carouselToUpdateId);

            return false;
        });

        //category more menu
        //
        //On resize execute checkIfCategoriesFits function with delay
        var resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function(){
                if (news.topSlider) {
                    news.topSlider.checkIfCategoriesFits('#carousel_slider_top .slick-current ');
                }
            }, 250);
        });

        $(window).resize(function() {
            var viewPortWidth = $(window).width();
            var firstNews = $('.carousel-slide-1 .main-news:first-of-type').first();
            var currBgImg = firstNews.css('background-image').replace('url("', '').replace('")', '');
            if (viewPortWidth < 480) {
                //check if currently we have big screen images and change them to small screen images
                if (firstNews.attr('data-bg_img') === currBgImg) {
                    $('.main-news, .header-s').each(function(){
                        news_image.switchBgImg($(this), $(this).attr('data-bg_mob'));
                    });
                }
            } else {
                //check if currently we have small screen images and change them to big screen images
                if (firstNews.attr('data-bg_mob') === currBgImg) {
                    $('.main-news, .header-s').each(function(){
                        news_image.switchBgImg($(this), $(this).attr('data-bg_img'));
                    });
                }
            }
        });

        //
        // lazy load images
        //
        $('.wrap-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

            var goRight = (nextSlide - currentSlide == 1) || (nextSlide - currentSlide < -1);
            var slideNr = nextSlide + (goRight ? +2 : 0);

            if (event.target.parentNode.id == "carousel_slider_top") {
                topNewsReload.postpone();
                news.topSlider.renderSlide(nextSlide+1);
                news.topSlider.renderSlide(slideNr);
            }

            var
                currSlide = '.carousel-slide-' + (nextSlide + 1) + ' ',
                nextNextSlide = '.carousel-slide-'+ (nextSlide+2)+' ',
                $nextSlideNewsItems = $(this).find(currSlide+' .main-news, '+currSlide+' .header-l, '+currSlide+' .header-s'),
                viewPortWidth = $(window).width();

            $nextSlideNewsItems.each(function () {
                var newsItemData = $(this).data();
                //for mobile phones chose smaller images
                if (viewPortWidth < 480 && newsItemData.bg_mob) {
                    $(this).css('background-image', 'url('+newsItemData.bg_mob+')');
                } else if (newsItemData.bg_img) {
                    $(this).css('background-image', 'url('+newsItemData.bg_img+')');
                }
            });

            //preload also next next slide main img
            var $nexNextSlideNewsItems = $(this).find(nextNextSlide+' .main-news');
            var nexNextSlideNewsItemData = $nexNextSlideNewsItems.data() || {};
            if (nexNextSlideNewsItemData.bg_img) {
                $nexNextSlideNewsItems.css('background-image', 'url('+nexNextSlideNewsItemData.bg_img+')');
            }

            // Call checkIfCategoriesFits function on slide change
            setTimeout(function () {
                // Refs: https://jira.dev.inbox.lv/browse/PORTAL-554
                try {
                    news.topSlider.checkIfCategoriesFits('#carousel_slider_top .slick-current ');
                }
                catch (e) {
                    // console.warn(e);
                }
            }, 250);
        });

        const newsModalEl = document.getElementById('modal-news');
        newsModalEl.addEventListener('hidden.bs.modal', () => {
            var modalIframe = newsModalEl.querySelector('iframe');
            if (modalIframe) {
                modalIframe.setAttribute('src', modalIframe.getAttribute('src'));
            }
        });


        $('#read_full_article, .modal-body > a').on('mouseup', function () {
            // This check is so on dev we don't have error as we disable analytics tracking on dev
            if (window.ga) {
                window.ga('otherTracker.send', 'event', 'NewsModal', 'ClickReadFull', $(this).data('source_name'),  1);
            }
            if($(this).data('news_id') > 0) {
                news_modal.countNewsClick('modal', 'read_more', $(this).data('news_id'), false);
            }
        });
        $('#read_full_article, .modal-body > a').on('click', function(e) {
            e.preventDefault();
            window.open($(this).attr('href'), '_blank');
        });

        //
        // open news modal window
        //

        $('#modal-news').on('show.bs.modal', function (e) {
            $('.modal-content').animate({ scrollTop: 0 });
            //link which was clicked to open modal
            var $relatedTarget = $(e.relatedTarget);
            var newsItemData = news_data.getNewsItemData($relatedTarget);
            var sliderId = $relatedTarget.closest('.carousel_outer_wrap').attr('id');
            news_modal.renderModal(newsItemData, sliderId);
            news_modal.countNewsClick('portal', 'open', newsItemData.id, true);
            if (sliderId == "carousel_slider_top") {
                topNewsReload.postpone();
            }
        });

        $('#modal-news').on('hidden.bs.modal', function () {
            //https://github.com/twbs/bootstrap/issues/33727
            document.querySelector('.modal-backdrop')?.remove();
        });
    });
};
